import { css } from 'styled-components';

export const SMSModalLink = css(
  ({ theme }) =>
    css`
      width: 432px;
      height: 388px;
      display: flex;
      flex-direction: column;
      gap: 48px;
      .modal-body {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .modal-title {
        font-weight: ${theme.font.weight.bold};
        font-size: 21px;
        line-height: 32px;
        text-align: center;
      }

      .modal-sub-title {
        width: 229px;
        color: ${theme.colors.primary};
        font-weight: ${theme.font.weight.normal};
        font-size: 14px;
        line-height: 21px;
        display: flex;
        align-items: center;
        text-align: center;
        margin-bottom: ${theme.spacing.larger}px;
      }

      .resend-link {
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;

        .resend-link-text {
          margin-bottom: 8px;
          color: ${theme.colors.primary};
        }
        .send-again-button {
          border: none;
          background-color: transparent;
          color: ${theme.colors.primaryLightBlue};
          cursor: pointer;
          font-size: 14px;
          &:disabled {
            cursor: default;
            color: #8090b4;
          }
        }
        .resend-timer {
          font-weight: ${theme.font.weight.normal};
        }
      }
    `
);
